<div class="top">
	<a class="back-btn" mat-stroked-button routerLink="/appointments">
		<mat-icon inline="true">arrow_back</mat-icon>
	</a>

	<h1 class="name">{{ patient.last_name }}, {{ patient.first_name }}</h1>

	<h1>{{ appointment.appointment_date | orgDate : "shortTime" }}</h1>
</div>

<div class="bottom">
	<div>
		<div class="title">Date of birth</div>
		<div>{{ patient.birthdate | date : 'MM/dd/yyyy' }}</div>
	</div>

	<div class="divider"></div>

	<div>
		<div class="title">Patient ID</div>
		<div>{{ patient.mrn }}</div>
	</div>

	<div class="divider"></div>

	<div>
		<div class="title">Age & Sex</div>
		<div>{{ patient | ageSex }}</div>
	</div>

	<div class="divider"></div>

	<div>
		<div class="title">Type</div>
		<div>{{ appointment.ehr_appointment_type_name }}</div>
	</div>

	<div class="divider"></div>

	<div>
		<div class="title">Phone</div>
		<div>{{ patient.phone }}</div>
	</div>

	<div class="divider"></div>

	<div>
		<div class="title">Provider</div>
		<div>{{ provider.last_name }}, {{ provider.first_name }}</div>
	</div>
</div>

